<template>
  <div class="quiz-answer" :class="{ 'quiz-answer--selected': isSelected, 'quiz-answer--correct':  isCorrect}">
    <h3 class="quiz-answer__title">{{ item.text }}</h3>
    <div class="quiz-answer__content" v-if="isSelected">{{ answer.title }}</div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({
        text: null
      })
    },
    answer: {
      type: Object,
      default: () => ({
        title: null
      })
    },
    isSelected: Boolean,
    isCorrect: Boolean
  }
}
</script>

<style lang="scss" scoped>
.quiz-answer {
  &.quiz-answer--selected {
    border: 2px solid $theme-gray-200;
    left: -10px;
    padding: 6px 8px;
    position: relative;
  }

  &__title {
    @include font-size($font-size-lg);
    font-weight: normal;

    .quiz-answer--correct & ,
    .quiz-answer--selected & {
      font-weight: 600;
    }

    .quiz-answer--selected & {
      color: $theme-red-100;
    }

    .quiz-answer--correct & {
      color: $theme-green;
    }
  }
}
</style>
